import mapFunction from './mapResources';

export default mapFunction('tablet_owners', {
    isFetching: false,
    items: []
});